// extracted by mini-css-extract-plugin
module.exports = {"layout":"BodySubWhenIsUseful_layout_2BzQD","template":"BodySubWhenIsUseful_template_ZSB5l"};